export enum ReportIDEnum {
    reportID_ARClaim                  = '9000000A-1000-0000-0000-000000000001',
    reportID_PatientStatement         = '9000000A-1000-0000-0000-000000000005',
    reportID_AllDoctors               = '9000000A-1000-0000-0000-000000000008',
    reportID_AgingAnalysis            = '9000000A-1000-0000-0000-000000000009',
    reportID_FinancialSummary         = '9000000A-1000-0000-0000-000000000010',
    reportID_FinancialSnapshot        = '9000000A-1000-0000-0000-000000000011',
    reportID_DailySnapshot            = '9000000A-1000-0000-0000-000000000012',
    reportID_FinancialSnapshotReport  = '9000000A-1000-0000-0000-000000000002',
    reportID_FrontDesk_Envelops       = '9000000A-1000-0000-0000-000000000013',
    reportID_FrontDesk_TreatmentPlan  = '9000000A-1000-0000-0000-000000000014',
    reportID_FrontDesk_WalkOutSlip    = '9000000A-1000-0000-0000-000000000015',
    reportID_Comparison_Report        = '9000000A-1000-0000-0000-000000000016',
    reportID_PerioChart_Report        = '9000000A-1000-0000-0000-000000000017',
    reportID_TransactionReport        = '9000000A-1000-0000-0000-000000000018',
    reportID_VoidedTransactionReport  = '9000000A-1000-0000-0000-000000000019',
    reportID_LedgerTransactionReport  = '9000000A-1000-0000-0000-000000000020',
    reportID_BankDeposits             = '9000000A-1000-0000-0000-000000000027',
    reportID_Financial_AuditReport    = '9000000A-1000-0000-0000-000000000028',
    reportID_List_of_Appointments     = '9000000A-1000-0000-0000-000000000029',
    reportID_Credit_Balance           = '9000000A-1000-0000-0000-000000000031',
    reportID_LedgerFormReport         = '9000000A-1000-0000-0000-000000000032',
    reportID_CreditCardReceiptReport  = '9000000A-1000-0000-0000-000000000033',
    reportID_RecallReport             = '9000000A-1000-0000-0000-000000000035',
    reportID_FeeCalculationReport     = '9000000A-1000-0000-0000-000000000037',
    reportID_ProceduresWithNoClaims   = '9000000A-1000-0000-0000-000000000038',
    reportID_ClaimsNoSent             = '9000000A-1000-0000-0000-000000000039',
    reportID_OutstandingClaims        = '9000000A-1000-0000-0000-000000000040',
    reportID_ReferringAnalysis        = '9000000A-1000-0000-0000-000000000041',
    reportID_PatientsNeedAppointment  = '9000000A-1000-0000-0000-000000000043',
}

export enum ReportClass {
    ReportViewer  = '00000278-1000-0000-0000-000000000001',
    UI            = '00000278-1000-0000-0000-000000000002',
    LettersOnly   = '00000278-1000-0000-0000-000000000003'
}

export enum ReportCategory {
    AccountRecevables = '00000098-1000-0000-0000-000000000001',
    Patient           = '00000098-1000-0000-0000-000000000002',
    Insurance         = '00000098-1000-0000-0000-000000000003',
    Referral          = '00000098-1000-0000-0000-000000000005',
    FrontDesk         = '00000098-1000-0000-0000-000000000006'
}





